export const TKeyLandingShared = {
  EXCHANGE_TAG_PAIN_POINT: "EXCHANGE_TAG_PAIN_POINT",
  EXCHANGE_TAG_BUYING_REASON: "EXCHANGE_TAG_BUYING_REASON",
  EXCHANGE_TAG_BUYING_SIGNAL: "EXCHANGE_TAG_BUYING_SIGNAL",
  EXCHANGE_TAG_POSITIVE_FEEDBACK: "EXCHANGE_TAG_POSITIVE_FEEDBACK",
  EXCHANGE_TAG_CUSTOMER_QUESTION: "EXCHANGE_TAG_CUSTOMER_QUESTION",
  EXCHANGE_TAG_OBJECTION: "EXCHANGE_TAG_OBJECTION",
  EXCHANGE_TAG_COMPETITOR_MENTION: "EXCHANGE_TAG_COMPETITOR_MENTION",
  EXCHANGE_TAG_DECISION_CRITERIA: "EXCHANGE_TAG_DECISION_CRITERIA",
  EXCHANGE_TAG_BUDGET: "EXCHANGE_TAG_BUDGET",
  EXCHANGE_TAG_TIMELINE: "EXCHANGE_TAG_TIMELINE",
  EXCHANGE_TAG_NEXT_STEP: "EXCHANGE_TAG_NEXT_STEP",
  EXCHANGE_TAG_CHURN_RISK: "EXCHANGE_TAG_CHURN_RISK",
  EXCHANGE_TYPE_NEGOTIATION: "EXCHANGE_TYPE_NEGOTIATION",
  EXCHANGE_TYPE_DISCOVERY: "EXCHANGE_TYPE_DISCOVERY",
  EXCHANGE_TYPE_FOLLOW_UP: "EXCHANGE_TYPE_FOLLOW_UP",
  EXCHANGE_TYPE_DEMO: "EXCHANGE_TYPE_DEMO",
  DEAL_STAGE_WON: "DEAL_STAGE_WON",
  DEAL_STAGE_LOST: "DEAL_STAGE_LOST",
  CUSTOMER_SYNTHESIS_TITLE: "CUSTOMER_SYNTHESIS_TITLE",
  CUSTOMER_RELATIONSHIP_ACTIVE: "CUSTOMER_RELATIONSHIP_ACTIVE",
} as const;
